

import * as actionType from './actions/vendorAction';

const initialState = {
    list: [],
    message: '',
    modalOpen: false,
    loading: false,
    isVendorEdit: false,
    isVendorList: true,
    isVendorCreate: false,
    apiStatus:false,
    AssetDetails:[]
}

const vendorReducer = (state = initialState, action) => {
    switch (action.type) {
        // case actionType.IS_VENDOR_EDIT:
            // return { ...state, isVendorEdit: action.payload }
        case actionType.GET_VENDOR_LIST:
            return { ...state, modalOpen: false,isVendorList:true,isVendorEdit:false,isVendorCreate:false, message: "", VendorDetails: action.payload }
        case actionType.GET_ASSET_DETAILS:
            return { ...state, modalOpen: false, message: "", AssetDetails: action.payload }
            case actionType.GET_VENDOR_CONTRACT_LIST:
            return { ...state, modalOpen: false,isVendorList:true,isVendorEdit:false,isVendorCreate:false, message: "", VendorContractDetails: action.payload }
      
        case actionType.GET_SELECTED_VENDOR:
            return { ...state, loading: false, modalOpen: false,isVendorEdit:true,isVendorList: false , message: "", VendorDetail: action.payload }
        case actionType.GET_SELECTED_VENDOR_FOR_SETTING:
            return { ...state,loading: false, isVendorEdit:false,message:'', VendorSelectedDetail: action.payload }
        case actionType.API_CALL_STATUS:
            return { ...state, loading: action.payload.loading,apiStatus:action.payload.apiStatus, modalOpen: action.payload.modalOpen, message: action.payload.message}
        case actionType.IS_VENDOR_EDIT:
            return { ...state, isVendorEdit: action.payload, isVendorList: false }
        case actionType.IS_VENDOR_CREATE:
            return { ...state, isVendorEdit: false,modalOpen:false, isVendorList: false, isVendorCreate: action.payload }
        case actionType.IS_VENDOR_LIST:
            return { ...state, isVendorEdit: false,isVendorCreate:false,modalOpen:false, isVendorList: action.payload }
            case actionType.GET_VENDOR_SUPPLY_LIST:
                return { ...state, vendorSuplyList: action.payload }
    
        default:
            return state
    }
}

export default vendorReducer;